/**
 * Eshop photogallery support
 * TODO: 3D model, magnify zoom button
 */
var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'edeeshopPhotogallery';

var	DEFAULTS = {
	magnifyEnabled: true,
	model3DEnabled: true,

	//selectors
	thumblistSelector: '.js_thumblist',
	thumbitemSelector: '> li > a',

	//events
	onAfterPhotoChange: 'EDEESHOP_PHOTOGALLERY_PHOTO_CHANGE'
};

var EdeeShopPhotogallery = function (selector, options) {
	this.$t = $(selector);
	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;

	// blank jquery objects used further
	this.zoomButton = null;

	this.activeDetail = 0;
	this.initialise_();
};

EdeeShopPhotogallery.prototype.initialise_ = function() {
	this.thumbs = $(this.options.thumblistSelector + ' ' + this.options.thumbitemSelector, this.$t);
	var thumbCount = this.thumbs.size();
	if (thumbCount > 0) {
		this.renderDetails_();
		if (thumbCount === 1) {
			$(this.options.thumblistSelector, this.$t).hide();
		} else {
			this.bindThumbnailsSelect_();
			this.renderControlArrows_();
		}
	}

	return true;
};

/**
 * render details from thumbnails
 * render initial zoom button
 */
EdeeShopPhotogallery.prototype.renderDetails_ = function() {
	this.$detailgallery = $('<ul class="gallery-detail"></ul>');
	var detailZoom = '';

	/**
	 * render single details
	 */
	for (var i=0; i < this.thumbs.size(); i++) {
		// add index to thumbnail for future use
		$(this.thumbs[i]).data('index', i);
		detailZoom = $(this.thumbs[i]).data('zoom') || '';

		// render detail
		$('<li' + (i === this.activeDetail ? ' class="active"' : '') + '>' +
			'	<img src="' + $(this.thumbs[i]).attr('href') + '" data-magnify-src="'+ detailZoom +'" alt/>' +
			(this.options.magnifyEnabled && detailZoom != '' ? '<a href="javascript:" class="gallery-controls gallery-controls-zoom zoom-in js_image-magnify-activate"></a>' : '') +
			'</li>').appendTo(this.$detailgallery);
	}

	/**
	 * set first thumbnail marked as active
	 */
	$(this.thumbs[this.activeDetail]).addClass('active');

	/**
	 * render zoom button
	 */
	this.renderZoomButton_($(this.thumbs[this.activeDetail]).data('zoom'));

	/**
	 * prepend this whole package to DOM
	 */
	this.$detailgallery.prependTo(this.$t);
};

/**
 * removes zoombutton from DOM
 * @private
 */
EdeeShopPhotogallery.prototype.clearZoomButton_ = function() {
	if (this.zoomButton instanceof $) {
		$(this.zoomButton).remove();
	}
};

/**
 * renders zoom button
 * @private
 */
EdeeShopPhotogallery.prototype.renderZoomButton_ = function(zoomImagePath) {
	/**
	 * feature is disabled
	 */
	if (!this.options.magnifyEnabled) {
		return false;
	}

	/**
	 * clear zoombutton first
	 */
	this.clearZoomButton_();
};

/**
 *
 * @private
 */
EdeeShopPhotogallery.prototype.renderControlArrows_ = function() {
	this.$controlArrows = $('<p class="gallery-controls"></p>');
	/* span unvnitř odkazu je kvůli nastylování pomocí bootstrap .glyphicon, eg:
		.prev span {
			.glyphicon;
			.glyphicon-ico-arrow;
		}
	*/
	var arrowLeft = $('<a href="javascript:" class="prev" data-dir="prev"><span></span></a>').appendTo(this.$controlArrows);
	var arrowRight = $('<a href="javascript:" class="next" data-dir="next"><span></span></a>').appendTo(this.$controlArrows);
	this.$controlArrows.appendTo(this.$t);
	this.bindControlArrows_();
};

EdeeShopPhotogallery.prototype.bindControlArrows_ = function() {
	var self_ = this;
	this.$controlArrows.on('click', '> a', function(event) {
		event.preventDefault();
		var dir = $(event.currentTarget).data('dir');

		// add or substract one
		self_.activeDetail = dir == 'prev' ? self_.activeDetail - 1 : self_.activeDetail + 1;

		// if reached prev threshold, push it to the last thumbnail
		self_.activeDetail = self_.activeDetail < 0 ? (self_.thumbs.size()) - 1  : self_.activeDetail;

		// if reached next trehshold, push it to the first thumbnail
		self_.activeDetail = self_.activeDetail > (self_.thumbs.size()) - 1 ? 0 : self_.activeDetail;


		self_.thumbnailChange_();
	});
};

/**
 * handle clicking on thumbnail
 * @private
 */
EdeeShopPhotogallery.prototype.bindThumbnailsSelect_ = function() {
	var self_ = this;
	$(this.options.thumblistSelector, this.$t).on('click', this.options.thumbitemSelector, function(event) {
		event.preventDefault();

		/**
		 * set active detail
		 * @type {Number}
		 */
		self_.activeDetail = parseInt($(event.currentTarget).data('index'));
		self_.thumbnailChange_();
	});
};

EdeeShopPhotogallery.prototype.thumbnailChange_ = function() {
	/**
	 * mark thumb as active
	 */
	this.setActiveThumbnail_();

	/**
	 * mark detail as active
	 */
	this.setActiveDetail_();

	/**
	 * trigger on after change
	 */
	this.$t.trigger(this.options.onAfterPhotoChange, [{
		instance: this
	}]);
};

EdeeShopPhotogallery.prototype.setActiveThumbnail_ = function() {
	$(this.thumbs).removeClass('active');
	$(this.thumbs[this.activeDetail]).addClass('active');
};

EdeeShopPhotogallery.prototype.setActiveDetail_ = function() {
	$(' > li', this.$detailgallery).removeClass('active');
	$(' > li:eq('+this.activeDetail+ ')', this.$detailgallery).addClass('active');
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new EdeeShopPhotogallery(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/edeeshop/jquery.edeeshop-photogallery.js